import { useAuthAdminApi } from './useAuthAdminApi';
import { useAuthAdminGetters } from './useAuthAdminGetters';
import { useAuthAdminHelpers } from './useAuthAdminHelpers';

import type { UseDjustAuthAdmin } from './types';
export function useDjustAuthAdmin(): UseDjustAuthAdmin {
  return {
    ...useAuthAdminApi(),
    ...useAuthAdminGetters(),
    ...useAuthAdminHelpers(),
  };
}
